import { render, staticRenderFns } from "./LocalesSwitcher.vue?vue&type=template&id=3c2e8c5a"
import script from "./LocalesSwitcher.vue?vue&type=script&lang=js"
export * from "./LocalesSwitcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c2e8c5a')) {
      api.createRecord('3c2e8c5a', component.options)
    } else {
      api.reload('3c2e8c5a', component.options)
    }
    module.hot.accept("./LocalesSwitcher.vue?vue&type=template&id=3c2e8c5a", function () {
      api.rerender('3c2e8c5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LocalesSwitcher.vue"
export default component.exports